export default __webpack_public_path__ + "static/media/degree.f2dab8ca.png";